import React from 'react';
import Loading from '../Loading/Loading';
import {useCurrentUser} from '../../contexts/CurrentUserProvider';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import FullForm from "./ComplaintForm/ContactUsFullForm";

/** @import {ContactUsProps} from './ContactUsTypes' */
function ContactUs(/** @type {ContactUsProps} */ props) {
    const currentUser = useCurrentUser();

    if (!currentUser || currentUser.isPending) {
        return <Loading message="We're loading your feedback form..."/>
    }

    return (
        <FullForm profile={props.profile}/>
    );
}

export default withFeatureFlags(ContactUs);
